import React from "react";
import PublicBookingLayout from "../components/PublicBooking/PublicBookingLayout";
import ThemedButton from "../components/Shared/ThemedButton";

const NotFoundPage = () => {
  return (
    <PublicBookingLayout>
      <div className="py-16">
        <div className="bg-themed-card rounded-lg shadow-sm border border-themed p-8">
          <div className="text-center">
            <div className="text-ink-400 mb-4">
              <svg
                className="w-20 h-20 mx-auto"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={1}
                  d="M9.172 16.172a4 4 0 015.656 0M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"
                />
              </svg>
            </div>
            <h1 className="text-4xl font-bold text-themed-primary mb-4">404</h1>
            <h2 className="text-2xl font-semibold text-themed-primary mb-4">
              Booking page not found
            </h2>
            <p className="text-themed-secondary mb-6 max-w-md mx-auto">
              Double-check the link you received, or contact the business for the correct booking page.
            </p>
            <ThemedButton
              onClick={() => window.history.length > 1 ? window.history.back() : window.location.href = '/'}
              className="inline-flex items-center"
            >
              Go back
            </ThemedButton>
          </div>
        </div>
      </div>
    </PublicBookingLayout>
  );
};

export default NotFoundPage;
